import React, { useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Hidden from "@material-ui/core/Hidden";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import MenuIcon from "@material-ui/icons/Menu";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Loader from 'components/general/Loader'

import { useLocation } from "react-router-dom";
import UserDropdownAlternative from "components/argon/Dropdowns/UserDropdownAlternative.js";
import componentStyles from "assets/theme/components/navbars/admin-navbar-alternative.js";

import {
    checkPrimaryPersonCompletion,
    checkCompanyProfileCompletion,
    checkRecommendationCardCompletion,
    checkAboutCompanyCompletion,
    checkTechnologyCompletion,
    checkProjectsCompletion,
    checkCompanyVerificationCompletion,
    checkWebsiteVerificationCompletion,
} from "config/helpers/Helpers";
import ProviderAPI from "config/api/ProviderAPI";

const useStyles = makeStyles(componentStyles);

function formatProgress(count, total) {
    if (!count || count === 0) return "Not started";
    return `${count}/${total} steps completed`;
}

function getCompanyProgress(company) {
    const checkers = [
        checkPrimaryPersonCompletion,
        checkCompanyProfileCompletion,
        checkRecommendationCardCompletion,
        checkAboutCompanyCompletion,
        checkTechnologyCompletion,
        checkProjectsCompletion,
    ];
    const total = checkers.length;
    let count = 0;
    checkers.forEach(fn => {
        if (fn(company) === 100) count++;
    });
    return { count, total, percent: Math.round((count / total) * 100) };
}

function getVerificationProgress(company) {
    const checkers = [
        checkCompanyVerificationCompletion,
        checkWebsiteVerificationCompletion,
    ];
    const total = checkers.length;
    let count = 0;
    checkers.forEach(fn => {
        if (fn(company) === 100) count++;
    });
    return { count, total, percent: Math.round((count / total) * 100) };
}

export default function AdminNavbarAlternative({ openSidebarResponsive, email, companyName, companyDetails }) {
    const classes = useStyles();
    const location = useLocation();
    const [showSearch, setShowSearch] = React.useState(false);

    // Dialog state
    const [showSubmitDialog, setShowSubmitDialog] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const isCompanyDetailsActive = location.pathname === "/complete-profile";
    const isVerificationDetailsActive = location.pathname === "/complete-verification";

    const isSolarProvider = companyDetails && companyDetails.productsAvailable && companyDetails.productsAvailable['Solar']
    const companyProgress = companyDetails && isSolarProvider ? getCompanyProgress(companyDetails) : { count: 0, total: 0, percent: 0 };
    const verificationProgress = companyDetails && isSolarProvider ? getVerificationProgress(companyDetails) : { count: 0, total: 0, percent: 0 };

    // Handler for submitting profile
    async function handleBackToDetails() {
        setSubmitting(true);
        try {
            const api = new ProviderAPI();
            await api.unsubmitProfile(companyDetails.companyId);
            window.location.reload();
        } catch (e) {
            setSubmitting(false);
        }
    }

    return (
        <AppBar position="relative" elevation={0} classes={{ root: classes.appBarRoot }}>
            <Toolbar disableGutters>
                <Container maxWidth={false} component={Box} classes={{ root: classes.containerRoot }}>
                    <Box display="flex" alignItems="center" width="100%" marginTop="1rem" marginBottom="1rem">
                        <Box display="flex" alignItems="center">
                            {/*companyDetails && !companyDetails.skipRegistration && (companyDetails.profileSubmitted !== true || companyDetails.verificationSubmitted !== true) && (
                                <>
                                    <Box marginRight="40px">
                                        <Typography
                                            variant="subtitle2"
                                            style={{
                                                color: isCompanyDetailsActive ? "#229626" : "#32325d",
                                                fontWeight: isCompanyDetailsActive ? 600 : 400,
                                                cursor: isCompanyDetailsActive ? "cursor" : "pointer",
                                                textDecoration: isCompanyDetailsActive ? "none" : "underline"
                                            }}
                                            onClick={isCompanyDetailsActive ? console.log('nothing') : () => setShowSubmitDialog(true)}
                                        >
                                            Step 1: Company Details
                                        </Typography>
                                        <Box display="flex" alignItems="center">
                                            {isCompanyDetailsActive && (
                                                <CircularProgress
                                                    size={14}
                                                    thickness={5}
                                                    value={companyProgress.percent}
                                                    variant="determinate"
                                                    style={{ marginRight: 6 }}
                                                />
                                            )}
                                            <Typography variant="caption" color="textSecondary">
                                                {formatProgress(companyProgress.count, companyProgress.total)}
                                            </Typography>
                                        </Box>
                                    </Box>

                                    <Box>
                                        <Typography
                                            variant="subtitle2"
                                            style={{
                                                color: isVerificationDetailsActive ? "#229626" : "#32325d",
                                                fontWeight: isVerificationDetailsActive ? 600 : 400,
                                            }}
                                        >
                                            Step 2: Verification
                                        </Typography>
                                        <Box display="flex" alignItems="center">
                                            {isVerificationDetailsActive && (
                                                <CircularProgress
                                                    size={14}
                                                    thickness={5}
                                                    value={verificationProgress.percent}
                                                    variant="determinate"
                                                    style={{ marginRight: 6 }}
                                                />
                                            )}
                                            <Typography variant="caption" color="textSecondary">
                                                {formatProgress(verificationProgress.count, verificationProgress.total)}
                                            </Typography>
                                        </Box>
                                    </Box>
                                </>
                            )*/}
                        </Box>

                        <Box flexGrow={1} />

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            marginLeft="auto"
                            className={clsx(classes.marginLeftNone, {
                                [classes.displayNone]: showSearch,
                            })}
                        >
                            <Hidden xlUp implementation="css">
                                <IconButton onClick={openSidebarResponsive}>
                                    <Box component={MenuIcon} width="1.5rem!important" height="1.5rem!important" />
                                </IconButton>
                            </Hidden>
                        </Box>

                        <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            className={clsx(classes.marginLeftAuto, {
                                [classes.displayNone]: showSearch,
                            })}
                        >
                            <UserDropdownAlternative companyName={companyName} />
                        </Box>
                    </Box>
                </Container>
            </Toolbar>

            {/* Confirmation Dialog */}
            <Dialog open={showSubmitDialog} onClose={() => setShowSubmitDialog(false)}>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                            <Box component={Typography} variant='h3'>
                                <Box component='span'>Back to Company Details?</Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} style={{ marginBottom: '1rem' }}>
                            <Typography>
                                Are you sure you want to navigate back to company details? You will need to submit your profile again.
                            </Typography>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowSubmitDialog(false)} color="primary" variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        onClick={handleBackToDetails}
                        color="primary"
                        variant="contained"
                        disabled={submitting}
                    >
                        {!submitting ? (
                            <>Back to Company Details</>
                        ) : (
                            <Loader height={12} />
                        )}
                    </Button>
                </DialogActions>
            </Dialog>
        </AppBar>
    );
}

AdminNavbarAlternative.defaultProps = {
    openSidebarResponsive: () => {},
};

AdminNavbarAlternative.propTypes = {
    openSidebarResponsive: PropTypes.func.isRequired,
    accountType: PropTypes.string,
    permissions: PropTypes.string,
};
